<template>
  <router-view></router-view>
</template>

<script>
import jwtDecode from "jwt-decode";

export default {
  name: 'TeamView',
  mounted() {
    let user_info = jwtDecode(localStorage.getItem("access")).user_info
    this.$store.state.tabs = [
      {
        'text': this.$t('operators'),
        'to': '/admin-operators'
      },
      {
        'text': this.$t('leader_board'),
        'to': user_info.is_admin ? '/leader' : '/operator/leader'
      }
    ]
  }
}
</script>
